// PaymentStatus.jsx

import React, { useState, useEffect } from "react";
import { useStripe } from "@stripe/react-stripe-js";
import { useDispatch, useSelector } from "react-redux";
import {
  customerCardAdded,
  customerCardAddedSuccess,
  getCustomerCards,
} from "../../../store/charges/action";
import { isEmpty } from "lodash";

import { toast } from "react-toastify";

const PaymentStatus = ({ setModalAddCustomerCard }) => {
  const dispatch = useDispatch();
  const stripe = useStripe();
  const [message, setMessage] = useState(null);

  const handleCustomerCardCreated = (setupIntent) => {
    const sendData = [
      {
        StripeSetupIntent: new URLSearchParams(window.location.search).get(
          "setup_intent_client_secret"
        ),
        StripePaymentMethod: setupIntent.payment_method,
      },
    ];
    dispatch(customerCardAdded(sendData));
  };
  const { customerCardAddedApiResponse } = useSelector((state) => ({
    customerCardAddedApiResponse: state.Charges.cardAddedSuccess,
  }));
  useEffect(() => {
    if (isEmpty(customerCardAddedApiResponse)) return;
    if (customerCardAddedApiResponse.status === 200) {
      // get current url strip everything after ?
      const url = window.location.href.split("?")[0];
      window.history.pushState({}, document.title, url);
      toast.success(customerCardAddedApiResponse.message);
      dispatch(getCustomerCards());
    } else {
      const url = window.location.href.split("?")[0];
      window.history.pushState({}, document.title, url);
      toast.error(customerCardAddedApiResponse?.message);

      // setModalAddCustomerCard(true);
    }

    dispatch(customerCardAddedSuccess([]));
  }, [customerCardAddedApiResponse]);
  useEffect(() => {
    if (!stripe) {
      return;
    }

    // Retrieve the "setup_intent_client_secret" query parameter appended to
    // your return_url by Stripe.js
    const clientSecret = new URLSearchParams(window.location.search).get(
      "setup_intent_client_secret"
    );

    // Retrieve the SetupIntent
    if (clientSecret !== null) {
      stripe.retrieveSetupIntent(clientSecret).then(({ setupIntent }) => {});
      stripe.retrieveSetupIntent(clientSecret).then(({ setupIntent }) => {
        // Inspect the SetupIntent `status` to indicate the status of the payment
        // to your customer.
        //
        // Some payment methods will [immediately succeed or fail][0] upon
        // confirmation, while others will first enter a `processing` state.
        //
        // [0]: https://stripe.com/docs/payments/payment-methods#payment-notification
        switch (setupIntent.status) {
          case "succeeded":
            setMessage("Success! Your payment method has been saved.");
            handleCustomerCardCreated(setupIntent);
            break;

          case "processing":
            setMessage(
              "Processing payment details. We'll update you when processing is complete."
            );
            break;

          case "requires_payment_method":
            // Redirect your user back to your payment page to attempt collecting
            // payment again
            setMessage(
              "Failed to process payment details. Please try another payment method."
            );
            break;
          default:
            break;
        }
      });
    }
  }, [stripe]);

  return message;
};

export default PaymentStatus;
